var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FieldText, ModalBody, ModalFoot, ModalHead, } from '@dixa/lib-shared-habla';
import { useState } from 'react';
import { Field, Form, reduxForm } from 'redux-form';
import { required } from 'redux-form-validators';
import { connectTwitterAccount } from 'components/settings/api/twitter';
import { NotificationType, useNotifications } from 'hooks/useNotifications';
const TwitterConnectForm = ({ handleSubmit, valid, onConnect, onCloseModal, twitterToken, defaultQueue, }) => {
    const notify = useNotifications();
    const [connectAsyncStatus, setConnectAsyncStatus] = useState('succeeded');
    const handleFormSubmit = (values) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        try {
            setConnectAsyncStatus('loading');
            const { auth_token, auth_token_secret } = twitterToken;
            const resp = yield connectTwitterAccount({
                auth_token,
                auth_token_secret,
                verifier: values.pin,
                queue_id: defaultQueue.id,
            });
            onConnect(resp.data);
            setConnectAsyncStatus('succeeded');
        }
        catch (e) {
            const error = e;
            notify({
                title: ((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status) === 406
                    ? 'Invalid Twitter PIN - please try again'
                    : 'An error occurred when trying to connect the Twitter account.',
            }, NotificationType.Error);
            setConnectAsyncStatus('failed');
        }
    });
    return (_jsxs(_Fragment, { children: [_jsx(ModalHead, { title: "Add Twitter account", onClose: onCloseModal }), _jsx(ModalBody, { children: _jsx(Form, Object.assign({ onSubmit: handleSubmit(handleFormSubmit) }, { children: _jsx(Box, { children: _jsx(Field, { label: "Pin", name: "pin", component: FieldText, validate: [required()], helpIcon: {
                                text: 'Authorize Twitter and enter the received pin here',
                            }, noAlert: true, required: true }) }) })) }), _jsx(ModalFoot, { confirmOnClick: handleSubmit(handleFormSubmit), confirmName: "Authorize", confirmProps: {
                    disabled: !valid,
                    isLoading: connectAsyncStatus === 'loading',
                }, cancelOnClick: onCloseModal })] }));
};
export const TwitterConnect = reduxForm({
    form: 'TwitterConnect',
    enableReinitialize: true,
})(TwitterConnectForm);
